import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRight = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "left" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "left",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "arrow-left",
				transform: "translate(9.500000, 8.000000) scale(-1, 1) translate(-9.500000, -8.000000) translate(4.000000, 0.000000)",
				fill: "currentColor",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Layer_2",
					children: /* @__PURE__ */ _jsx("polygon", {
						id: "Shape",
						points: "0.6 8 8.6 0 10.0666667 1.53333333 3.6 8 10.0666667 14.4666667 8.6 16"
					})
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgRight);
export default ForwardRef;
